import { render, staticRenderFns } from "./quitarPlanilla.vue?vue&type=template&id=aad86f26&"
import script from "./quitarPlanilla.vue?vue&type=script&lang=js&"
export * from "./quitarPlanilla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports